import React from 'react';
import {Link} from 'react-router-dom'
import {Navbar, Nav, Container} from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from './../redux/User/user.actions'
import logo from './../../src/assets/CD Horizontal_whiteFont_opt.png';
// import logo from './../../src/assets/CD_Horizontal-01_opt.png';

import * as ROUTES from './Routes'

const mapState = ({ user }) => ({
	currentUser: user.currentUser
})

const Header = props =>{
	const dispatch = useDispatch();
	const { currentUser } = useSelector(mapState);

	const signOut = () => {
		dispatch(signOutUserStart());
	};

	

	return(
		<header className="header">
			
			<Navbar collapseOnSelect expand="lg" variant="dark" fixed="top" className="mainNav">
			<Container>
  				<Navbar.Brand href={ROUTES.LANDING}>
					  <img className="head-logo" src={logo} alt="chore door logo"/>
				</Navbar.Brand>
  			<Navbar.Toggle aria-controls="responsive-navbar-nav" />
  			<Navbar.Collapse id="responsive-navbar-nav">
				<Nav className="ml-auto">
				<Nav.Link href={ROUTES.PLANS} >SERVICES</Nav.Link>
				{/* <Nav.Link href='#faq' >FAQ</Nav.Link> */}
				
				</Nav>
				
				{currentUser &&(
					<Nav>
						<li className="nav-link" onClick={() => signOut()}>Logout</li>
						<Link className="nav-link" to={ROUTES.DASHBOARD}>My Account</Link>

					</Nav>

				)}
				
				{!currentUser && (
					<Nav>
						<Nav.Link href={ROUTES.PLANS} >PLANS</Nav.Link>
						<Nav.Link href={ROUTES.VENDOR_LOGIN}>VENDORS</Nav.Link>
						<Nav.Link href={ROUTES.LOGIN}>SIGN IN</Nav.Link>
					</Nav>
				)}
				
		
			</Navbar.Collapse>
			</Container>
			</Navbar>
			
		</header>
	);
};

Header.defaultProps = {
	currentUser: null
};



export default Header;
